module.exports = __webpack_public_path__ + "static/media/settings.4d198ac5.svg";